<!-- eslint-disable -->
<template lang="pug">
    fields(
        :schoolId="schoolId"
        :gradeId="gradeId"
        :userId="userId"
        @search="$emit('search', $event)"
        ref="fields"
    )
</template>

<script>
    /*eslint-disable*/
    import Fields from '../Fields/Fields.vue'

    export default {
        props: ['schoolId', 'gradeId', 'userId'],
        components: {
            Fields
        },
        methods: {
            resetResults() {
                this.$refs.fields.resetResults();
            }
        }
    }
</script>
